import React, { useEffect,useRef, useState} from "react";
import { UserAuth } from "../Login/AuthContext";
import './Indiana.css';

import img2 from './Indimg/indimg2.webp'
import img3 from './Indimg/indimg3.webp'
import img4 from './Indimg/indimg4.webp'
import img5 from './Indimg/indimg5.webp'
import img6 from './Indimg/indimg6.webp'
import img7 from './Indimg/indimg7.webp'
import img8 from './Indimg/indimg8.webp'
import img9 from './Indimg/indimg9.webp'
import img10 from './Indimg/indimg10.webp'
import Back from "./Indimg/Indyvideo.mp4"
function Indiana(){
    const { user, logout } = UserAuth();
    useEffect(() => {
        logout();
   }, [])
return (
    <div className="indwrapper">
            <div className="ind-top">
             <div className="ind-top-img">
             {/* <img className="ind-i" src={img1}/> */}
             <video className="indyvideo" src={Back} autoPlay loop muted />
                 </div>
                 <div className="ind-top-content">  
            <div className="ind-top-title">Broad-Ocean Motor of Indiana</div>
                <div className="ind-top-text">Broad Ocean Motor relocated to a significantly larger facility in Brownsburg, Indiana in 2025, giving us the space, infrastructure, and technical environment to support far more advanced manufacturing, quality assurance, and logistics programs than ever before. The new building adds dedicated cleanroom capacity for SMT and PCB assembly, expanded production floors, and upgraded industrial systems including dual high output air compressors, HEPA filtered climate control, and backup power to protect critical operations. With additional dock doors, increased warehouse volume, and purpose built areas for assembly, testing, and sensitive component handling, the Brownsburg site enables scalable 3PL services, value added processing, and end to end contract manufacturing support for customers looking to grow, streamline, or diversify their Midwest U.S. operations.</div>

            </div>
            </div> 

    <div className="ind-mid">
        <div className="ind-mid-title">What We Do</div>
        <div className="ind-block">
            <div className="ind-block-left"><img className="ind-block-img" src={img10} /></div>
             <div className="ind-block-right">
                <div className="ind-block-title">Facility & Industrial Infrastructure Overview</div>
                <div className="ind-block-text">
                <li className="ind-li">Newly Constructed in 2025</li>
                <li className="ind-li">Centrally Located in Brownsburg, IN with easy access to Interstate 74</li>
                <li className="ind-li">95% of United States marketplace can be reached within 2-day transit time</li>
                <li className="ind-li">112k Ft2 available suitable for manufacturing and production</li>
                <li className="ind-li">14k Ft2 Cleanroom suitable for SMT PCB manufacturing and assembly</li>
                <li className="ind-li">135k Ft2 available warehouse space</li>
                <li className="ind-li">14 Loading Dock Doors</li>
                <li className="ind-li">Dual 37kw Ingersoll Rand Air Compressors with Desiccant air dryer and oil-free air filtration</li>
                <li className="ind-li">50kw NG Cummins backup generator for critical network systems uptime</li>
                </div>
            </div>
          
        </div>
        <div className="ind-block">
            <div className="ind-block-left"><img className="ind-block-img" src={img2} /></div>
             <div className="ind-block-right">
                <div className="ind-block-title">3PL Logistics Services</div>
              <div className="ind-block-text">
                <li className="ind-li">Readily available floor and pallet rack storage options</li>
                <li className="ind-li">End-to-End Warehousing, Distribution, and fulfillment</li>
                <li className="ind-li">Integrated WMS enables “Real-Time” inventory visibility</li>
                <li className="ind-li">Flexible staffing and scalable logistics operations</li>
                <li className="ind-li">Value added services tailored to your needs such as packaging, sorting, etc… </li>
                </div>
            </div>
        </div>

        <div className="ind-block">
            <div className="ind-block-left"><img className="ind-block-img" src={img3} /></div>
            <div className="ind-block-right">
                <div className="ind-block-title">CM Manufacturing Support Services</div>
                <div className="ind-block-text">We have the ability to perform tear down analysis and quality inspection on defective and damaged motors through the use of:
                <li className="ind-li">SMT-ready cleanroom space with industrial grade climate management, humidity control, HEPA filtration and anti-static systems</li>
                <li className="ind-li" >Assembly, testing, and light manufacturing support</li>
                <li className="ind-li">Quality-Controlled handling of sensitive components</li>
                <li className="ind-li">Scalable capacity for new product lines</li>
                <li className="ind-li">Support for long-term expansion plans</li>

                </div>
            </div>
        </div>



            <div>&nbsp;</div>
        <div className="hou-mid-title">State of the Art Laboratory</div>

        <div className="ind-block">
            <div className="ind-block-left"><img className="ind-block-img" src={img4} /></div>
            <div className="ind-block-right">
                <div className="ind-block-title">Magtrol Motor Test System</div>
                <div className="ind-block-text">Our dynamometer system allows us to quantify motor performance by measuring various properties including torque, angular velocity, electrical input power, and other variables.
Our system includes:
                <li className="ind-li">DSP7000 Dynamometer Controller</li>
                <li className="ind-li">6530 Power Analyzer</li>
                <li className="ind-li">STACO Power Supply 26V to 600V 3 Phase</li>
                <li className="ind-li">M-TEST 7 Motor Testing Software</li>
                <li className="ind-li">Four Dynamometers range from 3.3 Oz*Ft to 166.7 Oz*Ft</li>
                </div>
            </div>
        </div>


        {/* <div className="ind-block">
            <div className="ind-block-left"><img className="ind-block-img" src={img5} /></div>
            <div className="ind-block-right">
                <div className="ind-block-title">Furnace Lab</div>
                <div className="ind-block-text">Combustion and furnace efficiency rating testing can be performed in our combustion test lab.
                <li className="ind-li">ANSI Z21.47, ANSI/ASHRAE 103</li>
                <li className="ind-li">Combustion, AFUE, and FER testing</li>
                <li className="ind-li">Siemens Ultramat 23 for CO and CO2 analysis</li>
                <li className="ind-li">Inficon 3000 Micro Gas Chromatograph for gas heating value measurement</li>
                <li className="ind-li">Yokogawa WT1600 Digital Power Meter</li>
                <li className="ind-li">Labview DAQ</li>
                </div>
            </div>
        </div> */}


        <div className="ind-block">
            <div className="ind-block-left"><img className="ind-block-img" src={img6} /></div>
            <div className="ind-block-right">
                <div className="ind-block-title">ASHRAE 2500 SCFM Tunnel Test System</div>
                <div className="ind-block-text">The airflow tunnel at BOM-Indiana allows us to test in-unit motor performance by measuring motor input power and angular velocity, as well as airflow produced by UUT. A back pressure fan provides the ability to adjust the external static pressure across the UUT.
                <li className="ind-li">Conforms to ASHRAE 37, 41 and 51</li>
                <li className="ind-li">Flow range: 100 to 2500 SCFM, +/-1%</li>
                <li className="ind-li">ASHRAE nozzle: 1.6” to 6”</li>
                <li className="ind-li">LabVIEW DAQ based on Allen-Bradley Micrologix 1400 PLC, 16Bit A/D and D/A</li>
                <li className="ind-li">Temperature, Humidity, Pressure</li>
                </div>
            </div>
        </div>




        <div className="ind-block">
            <div className="ind-block-left"><img className="ind-block-img" src={img7} /></div>
            <div className="ind-block-right">
                <div className="ind-block-title">ASHRAE 4000 SCFM Tunnel Test System</div>
                <div className="ind-block-text">The airflow tunnel at BOM-Indiana allows us to test in-unit motor performance by measuring motor input power and angular velocity, as well as airflow produced by UUT. A back pressure fan provides the ability to adjust the external static pressure across the UUT.
                <li className="ind-li">Conforms to ASHRAE 37, 41 and 51</li>
                <li className="ind-li">Flow range: 100 to 4000 SCFM, +/-1%</li>
                <li className="ind-li">ASHRAE nozzle: 2”, 3”, 5.5” and 8”</li>
                <li className="ind-li">LabVIEW DAQ based on Allen-Bradley Micrologix 1400 PLC, 16Bit A/D and D/A</li>
                <li className="ind-li">Temperature, Humidity, Pressure</li>
                </div>
            </div>
        </div>


        <div className="ind-block">
            <div className="ind-block-left"><img className="ind-block-img" src={img8} /></div>
            <div className="ind-block-right">
                <div className="ind-block-title">CSZ Halt Chamber</div>
                <div className="ind-block-text">Stability testing, basic temperature cycling and accelerated stress testing can be performed
                <li className="ind-li">EZT-570-i Touch Screen Controller</li>
                <li className="ind-li">Temperature Range: -100°C to 200°C</li>
                <li className="ind-li">Rapid Temperature Ramp Rates at {'>'}90°C/min</li>
                <li className="ind-li">Vibration Range: 1 GRMS to 90 GRMS</li>
                <li className="ind-li">Fog-Free View Window and Interior Light</li>
                <li className="ind-li">Two side ports for ease of cable routing</li>
                <li className="ind-li">30” x 30” x 30” Interior Space</li>
                </div>
            </div>
        </div>


        <div className="ind-block">
            <div className="ind-block-left"><img className="ind-block-img" src={img9} /></div>
            <div className="ind-block-right">
                <div className="ind-block-title">CSZ Temperature Chamber</div>
                <div className="ind-block-text">Stability testing, basic temperature cycling and accelerated stress testing can be performed
                <li className="ind-li">EZT-570-i Touch Screen Controller</li>
                <li className="ind-li">Temperature Range: -34°C to 190°C with Forced Air</li>
                <li className="ind-li">Humidity Range: 10% to 98% RH</li>
                <li className="ind-li">Hermetically sealed unit to prevent moisture migration</li>
                <li className="ind-li">Fog-Free View Window and Interior Light</li>
                <li className="ind-li">Two 4” ports for ease of cable routing</li>
                <li className="ind-li">38” x 38” x 38” Interior Space</li>
                <li className="ind-li">Optional CSZ EZ-View Software for DAQ, Network Access, and Cloud Backup</li>
                
                </div>
            </div>
        </div>

    </div>



    </div>
  





);




}
export default Indiana;